import { Components } from '@ionic/core';
import { IonButton, isPlatform } from '@ionic/react';
import {
  DOMAttributes,
  HTMLAttributes,
  ReactElement,
  ReactNode,
  forwardRef,
} from 'react';

export type ButtonProps = Partial<Components.IonButton> &
  Partial<HTMLAttributes<HTMLIonButtonElement>> &
  Partial<DOMAttributes<HTMLIonButtonElement>>;
export interface BaseButtonProps {
  buttonId?: string;
  className?: string;
  children?: ReactNode;
  buttonProps?: ButtonProps;
}

const BaseButton = forwardRef<HTMLIonButtonElement, BaseButtonProps>(
  (props: BaseButtonProps, ref): ReactElement => {
    const { children, className, buttonProps } = props;

    const shape = isPlatform('ios') ? 'round' : undefined;

    return (
      <IonButton
        data-cy={props.buttonId}
        ref={ref}
        shape={shape}
        {...buttonProps}
        className={className}
      >
        {children}
      </IonButton>
    );
  }
);

BaseButton.displayName = 'BaseButton';

export { BaseButton };
